
import Vue from 'vue'
import Router from 'vue-router'

import routes from './common'

import { ROUTER_DEFAULT_CONFIG } from '@/config'
import { routerBeforeEachFunc, routerAfterEachFunc } from '@/config/interceptors/router'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 注入默认配置和路由表
const createRouter = () =>
  new Router({
    ...ROUTER_DEFAULT_CONFIG,
    routes
  })

const routerInstance = createRouter()
routerInstance.beforeEach(routerBeforeEachFunc)
routerInstance.afterEach(routerAfterEachFunc)

export function resetRouter() {
  const newRouter = createRouter()
  routerInstance.matcher = newRouter.matcher
}

window.mainAppRouter = routerInstance

export default routerInstance

export function getRouter() {
  return routerInstance
}
